import moment from 'moment';
import {
  CORREDOR_CP_CHANGE_FILTER_DATE,
  CORREDOR_CP_GET_LIST,
  CORREDOR_CP_GET_SUMMARY,
  CORREDOR_CP_UPDATE_LIST_URLS,
  CORREDOR_CP_CHANGE_FILTER_YEAR,
  startType,
  GET_LIQUIDACION_LIST,
  LIQUIDACION_DOCS_URLS,
} from '../constants/action-types';
import { DEFAULT_PAGE_SIZE } from '../../CONST';

const initialState = {
  list: {
    endosos: {
      data: [],
      pages: 0,
      count: 0,
      next: '',
      previous: '',
    },
    datesFilter: {
      startDate: moment(),
      endDate: moment(),
    },
    summary: null,
    xlsxUrl: '',
    pdfUrl: '',
  },
  loading: false,
  yearFilter: moment(),
  liquidacion: {
    list: [],
    xlsxUrl: '',
    pdfUrl: '',
  },
};

const initLoading = (state) => ({
  ...state,
  loading: true,
});

const getList = (state, action) => ({
  ...state,
  loading: false,
  list: {
    ...state.list,
    endosos: {
      ...state.list.endosos,
      data: action.payload.results,
      pages: Math.ceil(action.payload.count / DEFAULT_PAGE_SIZE),
      count: action.payload.count,
      next: action.payload.next,
      previous: action.payload.previous,
    },
  },
});

const changeFilterDate = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    datesFilter: {
      ...state.list.datesFilter,
      [action.payload.fieldName]: action.payload.value,
    },
  },
});

const getSummary = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    summary: action.payload,
  },
});

const updateListUrls = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    ...action.payload,
  },
});

const changeFilterYear = (state, action) => ({
  ...state,
  yearFilter: action.payload,
});

const getLiquidacionList = (state, action) => ({
  ...state,
  liquidacion: {
    ...state.liquidacion,
    list: action.payload,
  },
  loading: false,
});

const getLiquidacionUrls = (state, action) => ({
  ...state,
  liquidacion: {
    ...state.liquidacion,
    ...action.payload,
  },
});

function corredorCredito(state = initialState, action) {
  switch (action.type) {
    case startType(CORREDOR_CP_GET_LIST):
      return initLoading(state);
    case CORREDOR_CP_GET_LIST:
      return getList(state, action);
    case CORREDOR_CP_CHANGE_FILTER_DATE:
      return changeFilterDate(state, action);
    case CORREDOR_CP_GET_SUMMARY:
      return getSummary(state, action);
    case CORREDOR_CP_UPDATE_LIST_URLS:
      return updateListUrls(state, action);
    case CORREDOR_CP_CHANGE_FILTER_YEAR:
      return changeFilterYear(state, action);
    case startType(GET_LIQUIDACION_LIST):
      return initLoading(state);
    case GET_LIQUIDACION_LIST:
      return getLiquidacionList(state, action);
    case LIQUIDACION_DOCS_URLS:
      return getLiquidacionUrls(state, action);
    default:
      return state;
  }
}

export default corredorCredito;
